import { defineComponent as _defineComponent } from 'vue'
import _ from 'lodash';
import { withDefaults, ref } from 'vue';
import { Tooltip as ElTooltip } from 'element-ui';
import { Icon as PtIcon } from 'patsnap-biz';
import { POPPER_OPEN_DELAY } from '@/constants';
import { FetchCompareInit } from '@/infrastructure/api-functions/core-search-api/core-search-api';
import { injectService } from '@patsnap/tahiti-core/ioc/inject';
import { RavenInsertMeta } from 'library-@/services/sentry';
import { useI18n } from '@/composables/use-i18n';
import '@patsnap-ui/icon/assets/CompareGradient.svg';


export default /*#__PURE__*/_defineComponent({
  __name: 'CompareWithTag',
  props: {
    type: { default: 'button' },
    sourcePatentId: null,
    targetPatentId: null,
    relatedId: null,
    searchType: null,
    familyType: null,
    affectType: null,
    otherParams: { default: undefined },
    page: { default: 1 },
    rows: { default: 20 }
  },
  setup(__props: any) {

const props = __props as { type: string, sourcePatentId: string, targetPatentId: string, relatedId: string, searchType: string, familyType: string, affectType: string, otherParams: {
        sort_type: string;
        sort_order: string;
        semanticId: string;
    }, page: number, rows: number }

const { t } = useI18n();



const isLoading = ref(false);

function doCompare() {
    if (isLoading.value) return;
    RavenInsertMeta('View', 'Enter Patent Comparison From View');
    const service = injectService<FetchCompareInit>(FetchCompareInit);
    service.fetchCompareInit({
        related_id: props.relatedId,
        family_type: props.familyType,
        affect_type: props.affectType,
        type: props.searchType,
        sort_type: props.otherParams?.sort_type,
        sort_order: props.otherParams?.sort_order,
        semantic_id: props.otherParams?.semanticId,
    }).then(res => {
        const compareId = _.get(res, 'compare_id', '');
        if (compareId) {
            const href = `/patent-view/clms'clms/${props.sourcePatentId}'${props.targetPatentId}?compareId=${compareId}&page=${props.page}&rows=${props.rows}&_type=${props.searchType}`;
            const newTab = window.open();
            newTab!.opener = null;
            newTab!.location = href;
        }
    });
}

return { __sfc: true,t, props, isLoading, doCompare, ElTooltip, PtIcon, POPPER_OPEN_DELAY }
}

})